import { render, staticRenderFns } from "./MigrationItem.vue?vue&type=template&id=2841341a&"
import script from "./MigrationItem.vue?vue&type=script&lang=js&"
export * from "./MigrationItem.vue?vue&type=script&lang=js&"
import style0 from "./MigrationItem.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports